<div class="flex flex-col gap-(--space-6)">
  <div>
    <h3 class="font-medium mb-(--space-3)">{{ 'graphs.exportDialog.formatTitle' | transloco }}</h3>
    <div class="flex flex-col gap-(--space-3)">
      <div class="flex items-center gap-(--space-2)">
        <p-radioButton name="format" value="png" [(ngModel)]="selectedFormat" inputId="format-png" />
        <label for="format-png" class="cursor-pointer">
          <span class="font-medium">PNG</span>
          <span class="text-(color:--text-secondary) ml-(--space-2)">{{ 'graphs.exportDialog.pngDescription' | transloco }}</span>
        </label>
      </div>
      <div class="flex items-center gap-(--space-2)">
        <p-radioButton name="format" value="svg" [(ngModel)]="selectedFormat" inputId="format-svg" />
        <label for="format-svg" class="cursor-pointer">
          <span class="font-medium">SVG</span>
          <span class="text-(color:--text-secondary) ml-(--space-2)">{{ 'graphs.exportDialog.svgDescription' | transloco }}</span>
        </label>
      </div>
      <div class="flex items-center gap-(--space-2)">
        <p-radioButton name="format" value="pdf" [(ngModel)]="selectedFormat" inputId="format-pdf" />
        <label for="format-pdf" class="cursor-pointer">
          <span class="font-medium">PDF</span>
          <span class="text-(color:--text-secondary) ml-(--space-2)">{{ 'graphs.exportDialog.pdfDescription' | transloco }}</span>
        </label>
      </div>
    </div>
  </div>

  @if (showOrientation()) {
    <div>
      <h3 class="font-medium mb-(--space-3)">{{ 'graphs.exportDialog.orientationTitle' | transloco }}</h3>
      <div class="flex gap-(--space-4)">
        <div class="flex items-center gap-(--space-2)">
          <p-radioButton name="orientation" value="landscape" [(ngModel)]="selectedOrientation" inputId="orientation-landscape" />
          <label for="orientation-landscape" class="cursor-pointer">{{ 'graphs.exportDialog.landscape' | transloco }}</label>
        </div>
        <div class="flex items-center gap-(--space-2)">
          <p-radioButton name="orientation" value="portrait" [(ngModel)]="selectedOrientation" inputId="orientation-portrait" />
          <label for="orientation-portrait" class="cursor-pointer">{{ 'graphs.exportDialog.portrait' | transloco }}</label>
        </div>
      </div>
    </div>
  }

  <div>
    <h3 class="font-medium mb-(--space-3)">{{ 'graphs.exportDialog.optionsTitle' | transloco }}</h3>
    <div class="flex flex-col gap-(--space-3)">
      <div class="flex items-center gap-(--space-2)">
        <p-checkbox [(ngModel)]="includeTitle" [binary]="true" inputId="include-title" />
        <label for="include-title" class="cursor-pointer">{{ 'graphs.exportDialog.includeTitle' | transloco }}</label>
      </div>
      <div class="flex items-center gap-(--space-2)">
        <p-checkbox [(ngModel)]="includeLegend" [binary]="true" inputId="include-legend" />
        <label for="include-legend" class="cursor-pointer">{{ 'graphs.exportDialog.includeLegend' | transloco }}</label>
      </div>
      <div class="flex flex-col gap-(--space-1)">
        <label for="header-text" class="text-sm">{{ 'graphs.exportDialog.headerText' | transloco }}</label>
        <input pInputText id="header-text" [(ngModel)]="headerText" class="w-full" />
      </div>
    </div>
  </div>

  <ces-dialog-footer [submitLabel]="'common.buttons.export' | transloco" (onSubmit)="export()" (onCancel)="cancel()">
    <ces-button-tertiary
      footer-start
      [label]="isCopying() ? ('graphs.exportDialog.copying' | transloco) : ('graphs.exportDialog.copy' | transloco)"
      icon="content_copy"
      [disabled]="isCopying()"
      (onClick)="copyToClipboard()" />
  </ces-dialog-footer>
</div>
